import { ClientsRequestInterface } from '../../../interfaces/request/clients/clients-request-interface';

export class ClientsRequestModel implements ClientsRequestInterface {
  cardNumber: string = '';
  clientName: string = '';
  fiscalNumber: string = '';
  page: number | undefined;
  pageSize: number | undefined;
  policyNumber: string = '';

  constructor(init?: Partial<ClientsRequestModel>) {
    Object.assign(this, init);
  }
}
